import React from "react";
import { Theme } from "../types";

const ThemeContext = React.createContext({
  theme: "light" as Theme,
  setTheme(theme: Theme) {}
});

export default ThemeContext;
